import { Component, createEffect, Show } from 'solid-js';
import { useLocation, useNavigate } from '@solidjs/router';
import { useAppData } from '~/components/AppData';
import { getSlug, PublicPagePath } from '~/components/AppRouter/utils.ts';
import QuickStartWelcomeModal from '~/pages/Quickstart/QuickStartWelcomeModal';
import UserOnboardingModal from '~/pages/Onboarding/UserOnboardingModal';
import logger from '~/utils/logger';
import WorkspaceBillingContextProvider from '~/pages/Billing/contexts/WorkspaceBillingContext.tsx';

export default function withSession(component: Component): Component {
  const Renderer = component;
  return () => {
    const appData = useAppData();
    const location = useLocation();
    const navigate = useNavigate();

    createEffect(() => {
      if (!appData) {
        // Someone accesses the base path `/`
        navigate(`${getSlug.workspaceBaseNamespace()}`, {
          replace: true
        });
      } else if (!appData.isLoggedIn) {
        logger.info(`withSession :: redirecting to the login`);
        const urlParams = new URLSearchParams({
          redirectTo: location.pathname
        });
        window.location.assign(
          `${getSlug.workspaceBaseNamespace()}${getSlug.publicPage(PublicPagePath.LOGIN)}?${urlParams.toString()}`
        );
      }
    });

    function shouldShowUserOnboarding() {
      //This modal logic should work only for the new invited user
      return !!appData.environments?.length && !appData.member?.firstName;
    }

    return (
      <Show when={appData?.isLoggedIn}>
        <WorkspaceBillingContextProvider>
          {shouldShowUserOnboarding() && <UserOnboardingModal />}
          <QuickStartWelcomeModal />
          <Renderer />
        </WorkspaceBillingContextProvider>
      </Show>
    );
  };
}
